export default function Section10() {
    return (
      <div className="w-full Section10 py-[80px] md:py-[120px] bg-white">
        <div className="w-[90%] md:w-[61%] mx-auto text-center">
          {/* Headline */}
          <h2 className="text-[28px] md:text-[36px] font-bold text-[#151515] leading-[32px] md:leading-[41px] mb-6">
            Grow Your Organic Traffic and Revenue Today
          </h2>
  
          {/* Content */}
          <p className="text-gray-600 text-sm md:text-base mb-10">
            Partner with Mean3 for technical and growth-focused SEO campaigns that increase your visibility, attract qualified leads, and drive real business results.
          </p>
  
          {/* CTA Buttons */}
          <div className="flex flex-col md:flex-row justify-center items-center gap-6">
            <a
              href="https://mean3.com/contact-mean3/"
              className="bg-[#DA2128] text-white py-3 px-8 rounded-md font-semibold hover:bg-red-700 transition"
            >
              Book Your Free SEO Audit
            </a>
            <a
              href="https://mean3.com/contact-mean3/"
              className="border border-[#DA2128] text-[#DA2128] py-3 px-8 rounded-md font-semibold hover:bg-[#DA2128] hover:text-white transition"
            >
              Schedule a Strategy Session
            </a>
          </div>
        </div>
  
        {/* Optional Divider */}
        <div className="line mt-16 mb-[55px] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
      </div>
    );
  }
  